<template src="./html/Show.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	//import Buttons from './Buttons.vue'
	import Navbar from './Navbar.vue'
	export default {
		props: ['user', 'isAuth'],
		components: {
			//'buttons': Buttons,
			'navbar': Navbar,
		},
		data () {
			return {
				data: null,

				prefix: null,
				number_invoice_provider: null,
				reference: null,
				orders: [],
			}
		},
		created () {
			this.init()
		},
		watch: {
			'$route': function () {
				this.data = null
				this.getData()
			},
		},
		methods: {
			init() {
				this.getData()
			},
			reloadData() {
				this.getData()
			},
			getData() {
				this.$http.get('admin/management/invoices/' + this.$route.params.id)
				.then(response => {
					this.data = response.body
					this.prefix = this.data.prefix
					this.number_invoice_provider = this.data.number_invoice_provider
					this.reference = this.data.reference
					this.groupByOrders()
				}).catch(function(response) {
					console.log(response)
				})
			},
			print() {
				$(".printableArea").printThis()
			},
			changeNumber() {
				var that = this
				var loading = Ladda.create(this.$refs.btnNumber)
				loading.start()
				var data = {
					prefix: this.prefix,
					number_invoice_provider: this.number_invoice_provider,
					reference: this.reference,
				}
				this.$http.put('admin/management/invoices/' + this.data.id + '/update', data)
				.then(response => {
					loading.stop()
					this.reloadData()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type
					})
				}).catch(function(response) {
					console.log(response)
					loading.stop()
					this.reloadData()
				})
			},
			groupByOrders() {
				var orders = []
				if(this.data.orders) {
					if(this.data.orders.length > 0) {
						var that = this
						this.data.orders.forEach(function(order) {
							order.products = that.data.products.filter(function(product) {
								return product.order_id == order.id
							});
							orders.push(order)
						})
					}
				}
				this.orders = orders
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/invoices/views/Show.vue